<template>
  <div>
    <a-table
      class="assetFlowTable"
      id="tableDataTabs"
      bordered
      :pagination="false"
      :columns="tableData.columns"
      :rowKey="record => record.id"
      :dataSource="tableData.data"
      :loading="tableData.loading"
      @expand="expand"
      :expandedRowKeys="expandedRowKeys">
      <template slot="flow" slot-scope="text, record">
        <a href="javascript:;" v-if="record.children" @click.stop="() => handleStart(record)">发起流程</a>
      </template>
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" v-if="!record.children" @click.stop="() => handleDetail(record)">详情</a>
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initData()
      },
      immediate: true
    }
  },
  data () {
    return {
      tableData: {
        data: [
          {
            id: 1,
            name: '资产盘点',
            children: [
              {
                id: 11,
                number: '0000000-01',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 12,
                number: '0000000-02',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 13,
                number: '0000000-03',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 14,
                number: '0000000-04',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              }
            ]
          },
          {
            id: 2,
            name: '领用申请',
            children: [
              {
                id: 21,
                number: '0000000-01',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 22,
                number: '0000000-02',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 23,
                number: '0000000-03',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 24,
                number: '0000000-04',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              }
            ]
          },
          {
            id: 3,
            name: '调拨申请',
            children: [
              {
                id: 31,
                number: '0000000-01',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 32,
                number: '0000000-02',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 33,
                number: '0000000-03',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              },
              {
                id: 34,
                number: '0000000-04',
                creatorName: '顾清寒',
                createTime: '2022-11-10 13:31'
              }
            ]
          },
          {
            id: 4,
            name: '归还申请',
            children: []
          },
          {
            id: 5,
            name: '报废申请',
            children: []
          },
          {
            id: 6,
            name: '维修申请',
            children: []
          }
        ],
        columns: [
          {
            title: '',
            align: 'center',
            width: 50
          },
          {
            title: '序号',
            customRender: (text, record, index) => {
              if (record.children) {
                return index + 1
              }
            },
            align: 'center',
            width: 50
          },
          {
            title: '流程名称',
            dataIndex: 'name'
          },
          {
            title: '发起流程',
            scopedSlots: {
              customRender: 'flow'
            }
          },
          {
            title: '流程号',
            dataIndex: 'number'
          },
          {
            title: '创建人',
            dataIndex: 'creatorName'
          },
          {
            title: '创建时间',
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            width: 175
          }
        ],
        loading: false
      },
      pagination: {
        size: 'small',
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      expandedRowKeys: []
    }
  },
  methods: {
    initData () {},
    expand (expanded, record) {
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { // 进这个判断说明当前已经有展开的了
        // 返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        const index = this.expandedRowKeys.indexOf(record.id)
        if (index > -1) { // 如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          // 如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(record.id)
        }
      } else {
        // 数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(record.id)
      }
    },
    handleStart (record) {},
    handleDetail (record) {}
  }
}
</script>

<style lang="less" scoped>
.assetFlowTable{
  margin-left: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  // margin-bottom: 10px;
  /deep/.ant-table{
    //.ant-table-thead{
    //  > tr{
    //    > th{
    //      background: #E7F4FF !important;
    //      //background: rgba(8,64,159,0.1);
    //    }
    //  }
    //}
    .ant-table-row-expand-icon {
      margin-right: 0;
    }
  }
  /deep/.ant-table-bordered{
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td{
      border-color: #DDDDDD;
    }
    .ant-table-header > table,
    .ant-table-body > table,
    .ant-table-fixed-left table,
    .ant-table-fixed-right table{
      border-color: #DDDDDD;
    }
  }
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  margin-left: -1px;
  margin-right: -1px;
  margin-bottom: -1px;
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
